const table = {
  pagination: {
    rowsPerPage: 'Rows per page',
    page: 'Page {{current}}',
    pageOf: 'Page {{current}} of {{total}}',
    firstPage: 'First page',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    lastPage: 'Last page',
  },
} as const;

export default table;
